import React from "react";
import { cn } from "../../lib/utils";

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  rightElement?: React.ReactNode,
  leftElement?: React.ReactNode,
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, leftElement, rightElement, ...props }, ref) => {
    return (
      <div data-component-id="src/components/ui/input.tsx:12:6" data-component-path="src/components/ui/input.tsx" data-component-line="12" data-component-file="input.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22relative%20%22%7D" className="relative ">
        {leftElement && (
          <div data-component-id="src/components/ui/input.tsx:14:10" data-component-path="src/components/ui/input.tsx" data-component-line="14" data-component-file="input.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20left-3%20top-1%2F2%20transform%20-translate-y-1%2F2%20cursor-pointer%20text-black%22%7D" className="absolute left-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-black">
            {leftElement}
          </div>
        )}
        <input data-component-id="src/components/ui/input.tsx:18:8" data-component-path="src/components/ui/input.tsx" data-component-line="18" data-component-file="input.tsx" data-component-name="input" data-component-content="%7B%22elementName%22%3A%22input%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
          ref={ref}
          className={cn(
            "border border-[#E6E6E6] rounded-md px-[16px] py-[8px] w-full pr-10 rounded-[50px] text-[16px]",
            className
          )}
          {...props}
        />
        {rightElement && (
          <div data-component-id="src/components/ui/input.tsx:27:10" data-component-path="src/components/ui/input.tsx" data-component-line="27" data-component-file="input.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22absolute%20right-3%20top-1%2F2%20transform%20-translate-y-1%2F2%20cursor-pointer%20text-black%22%7D" className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-black">
            {rightElement}
          </div>
        )}
      </div>
    );
  }
);

Input.displayName = "Input";
